import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as revisionDocumentApi from "../../api/documentApi/revisionDocumentApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import {
  EQRevisionDocument,
  initializeRevisionDocument,
  revisionTypeNames,
} from "../../models/serverModels/workOrder/EQRevisionDocument";
import RevisionDocumentForm from "./RevisionDocumentForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {revisionDocumentSchema} from "../../validation/revisionDocumentSchema";

const CreateRevisionDocument = () => {
  const {state} = useLocation();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQRevisionDocument>,
    Params.Create<EQRevisionDocument>
  >({
    api: revisionDocumentApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Document/ListRevision/${state}`);
        queryClient.invalidateQueries("RevisionDocumentList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<EQRevisionDocument>({
    defaultValues: initializeRevisionDocument(state),
    resolver: yupResolver(revisionDocumentSchema),
  });

  const onSubmit: SubmitHandler<EQRevisionDocument> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeRevisionDocument(state), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle={revisionTypeNames[state]} />
      {isLoading && <MWProgress />}

      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <RevisionDocumentForm subText="파일 등록" />
          <ConfirmButtonGroup
            link={`/Document/ListRevision/${state}`}
            cancelText="취소"
            confirmText="추가"
          />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateRevisionDocument;
